import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";
import * as formatHelper from "../helpers/formatHelper";

export const getAutotasks = () => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_GET_AUTOTASKS
    },
    method: handlers.MACHINE_GET_AUTOTASKS,
    tabId: 0,
    safe: true
});

export const deleteAutotask = (id) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_AUTOTASK_DELETE,
        params: {
            id: id
        }
    },
    method: handlers.MACHINE_AUTOTASK_DELETE,
    tabId: 0,
    safe: true
});

export const addAutotask = (autotask) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_AUTOTASK_ADD_GENERIC,
        params: {
            actionType: autotask.actionType,
            startType: autotask.startType,
            name: autotask.name,
            runInterval: autotask.runInterval,
            runIntervalParams: {
                days: autotask.runMonthDays,
                weekdays: autotask.runWeekDays
            },
            firstRun: autotask.nextRun === null ? null : formatHelper.formatDateTimeForServer(autotask.nextRun),
            enabled: autotask.enabled,
            canPostpone: autotask.canPostpone,
            params: {
                volume: autotask.volume,
                formula: autotask.formula,
                channels: autotask.channels,
                cleaningTime: autotask.cleaningTime,
                recirculationTime: autotask.recirculationTime,
                recirculationSpeed: autotask.recirculationSpeed,
                stirringTime: autotask.stirringTime,
                stirringSpeed: autotask.stirringSpeed,
                canisters: autotask.canisters,
                threshold: autotask.threshold
            }
        }
    },
    method: handlers.MACHINE_AUTOTASK_ADD_GENERIC,
    tabId: 0,
    safe: true
});

export const updateAutotask = (autotask) => ({
    type: actionTypes.RCC_REQUEST,
    payload: {
        type: methods.METHOD_MACHINE_AUTOTASK_UPDATE_GENERIC,
        params: {
            id: autotask.id,
            startType: autotask.startType,
            name: autotask.name,
            runInterval: autotask.runInterval,
            runIntervalParams: {
                days: autotask.runMonthDays,
                weekdays: autotask.runWeekDays
            },
            nextRun: autotask.nextRun === null ? null : formatHelper.formatDateTimeForServer(autotask.nextRun),
            enabled: autotask.enabled,
            canPostpone: autotask.canPostpone,
            params: {
                volume: autotask.volume,
                formula: autotask.formula,
                channels: autotask.channels,
                cleaningTime: autotask.cleaningTime,
                recirculationTime: autotask.recirculationTime,
                recirculationSpeed: autotask.recirculationSpeed,
                stirringTime: autotask.stirringTime,
                stirringSpeed: autotask.stirringSpeed,
                canisters: autotask.canisters,
                threshold: autotask.threshold
            }
        }
    },
    method: handlers.MACHINE_AUTOTASK_UPDATE_GENERIC,
    tabId: 0,
    safe: true
});
